/**
* @ngdoc directive
* @name Decimals No Change
*
* @element input
*
* @description
  Same as decimals, but does not reset value to 0 on blur if value has error
*
* @attributes
* @param {Number} minValue - optional
* @param {Number} maxValue - optional
*
* @example
  <input
    ng-init='value="0"'
    class='form-control'
    decimals-no-change='money'
    ng-model='value'
  />
*/

(function () {
  'use strict';

  directive.$inject = ["$timeout", "FORMAT"];
  app.directive('decimalsNoChange', directive);

  function directive($timeout, FORMAT) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: link,
      priority: 100
    };

    function link(scope, element, attr, ngModel) {
      var format = FORMAT[attr.decimalsNoChange] || attr.decimalsNoChange;

      init();

      function init() {
        ngModel.$validators.decimals = function (modelValue, viewValue) {
          var isInvalidValue = isInvalid(viewValue);
          setError(isInvalidValue);
          return !isInvalidValue;
        };
        attr.$set('type', 'text');
        ngModel.$parsers.push(parseDecimal);
        ngModel.$formatters.push(formatDecimal);
      }

      /*
        Formatter and parser
      */

      function formatDecimal(value) {
        return numeral(value).format(format);
      }

      function parseDecimal(value) {
        return numeral().unformat(value);
      }

      /*
        Validators
      */

      function isInvalid(viewValue) {
        var unformattedValue = parseDecimal(viewValue);
        return viewValue !== undefined &&
          (isInvalidFormat(viewValue) ||
           isNaN(numeral().unformat(viewValue)) ||
           attr.maxValue && unformattedValue > attr.maxValue ||
           attr.minValue && unformattedValue < attr.minValue);
      }

      function isInvalidFormat(value) {
        if (value) {
          // remove spaces
          var valueNormalized = jQuery.trim(value).replace(/\,/g, '');
          if (!valueNormalized) {
            return false;
          }

          // remove only first dollar or last %
          var lastCharIndex = valueNormalized.length - 1;
          if (valueNormalized[0] === '$' || valueNormalized.substring(0,2) === '-$') {
            valueNormalized = valueNormalized.replace('$', '');
          } else if (valueNormalized[lastCharIndex] === '%') {
            valueNormalized = valueNormalized.substring(0, lastCharIndex);
          }
          if (!valueNormalized) {
            return false;
          }

          // remove only last "."
          lastCharIndex = valueNormalized.length - 1;
          if (valueNormalized[lastCharIndex] === '.') {
            valueNormalized = valueNormalized.substring(0, lastCharIndex);
          }
          if (!valueNormalized) {
            return false;
          }

          // allow only 123, 123. , 123.12 , .12 formats
          return !/^-?\d*(\.\d{1,2})?$/.test(valueNormalized);
        }
        return false;
      }

      function setError(shouldShowError) {
        if (shouldShowError) element.tooltip({ trigger: 'manual' }).tooltip('show');
        else element.tooltip('destroy');
      }

      // Formats the displayed value when the input field loses focus
      element.on('blur', function () {
        if (!isInvalid(element.val())) {
          element.val(formatDecimal(element.val()));
        }
      });

      element.on('focus', function () {
        $timeout(function () {
          try {
            element.get(0).setSelectionRange(0, 100);
          } catch (e) {
            try {
              element.get(0).select();
            } catch (e2) {}
          }
        }, 20);
      });
    }
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/decimalsNoChange.js